module.exports = __webpack_public_path__ + "static/media/new_behaviour_recording.71a23ef6.PNG";